<template>
  <v-btn
    color="primary"
    dark=""
    class="mr-2 ml-2 mb-2"
    @click="makeWeaponPDF()"
  >
    PDF
    <v-icon right>mdi-file-pdf-outline</v-icon>
  </v-btn>
</template>

<script>
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import { compareBy, groupWithSystems, isSystem } from "@/views/component/weaponSystemUtils";

export default {
  name: "WeaponPDFExport",
  props: {
    pdf_data: {
      type: Array
    },
    name: {
      type: String
    },
    club_user: {
      type: String
    }
  },
  data: () => ({}),
  methods: {
    makeWeaponPDF() {
      var source = this.pdf_data || [];
      const isUser = this.club_user === "UserApp";
      let rows = [];
      let columnHeader = [
        "Art",
        "WBK",
        "Beschreibung",
        "Erwerb",
        "Hersteller",
        "Kaliber",
        "NWR WID",
        "Nummer"
      ];
      // Nur für Schützen – beim Verein fehlte die Überschrift, die Werte kamen trotzdem mit
      if (isUser) columnHeader.push("Über Kontigent");

      let pdfName = "Waffen von " + this.name;
      let pdfDateiName = "Waffen von " + this.name;
      let pdfImage = "/Bilder/book.png";
      const exported = source.filter(
        element => element.export_weapon === true || element.export_weapon === 1
      );
      // Wechselsysteme direkt unter ihrer Grundwaffe, wie in der Tabelle
      groupWithSystems(exported, compareBy("KurzT")).forEach(element => {
        var temp = [];
        temp.push(
          this.artLabel(element, source),
          element.WBK,
          element.Beschreibung,
          new Date(element.Erwerb.replace(" ", "T")).toLocaleString([], {
            dateStyle: "short"
          }),
          element.Hersteller,
          element.Kaliber,
          element.NWR_WID,
          element.Nummer
        );
        if (isUser) temp.push(element.ueber_kontigent ? "Ja" : "Nein");

        rows.push(temp);
      });

      var doc = new jsPDF({
        orientation: "landscape"
      });
      // Header
      doc.setFontSize(20);
      doc.setTextColor(40);
      doc.text(pdfName, 10, 22);
      doc.setFontSize(12);
      doc.text(
        "Erstellt am " +
          new Date().toLocaleString([], {
            dateStyle: "short",
            timeStyle: "short"
          }) +
          " von schuetzenbuch.de",
        10,
        30
      );
      doc.addImage(pdfImage, "PNG", 265, 15, 20, 20);

      autoTable(doc, {
        head: [columnHeader],
        body: rows,
        startY: 40,
        margin: { horizontal: 10 },
        styles: { overflow: "linebreak" },
        bodyStyles: { valign: "top" },
        columnStyles: { email: { cellWidth: "wrap" } },
        theme: "striped",
        showHead: "everyPage",
        didDrawPage: function(data) {
          // Footer
          var str = "Seite " + doc.internal.getNumberOfPages();

          doc.setFontSize(10);

          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
        }
      });
      doc.save(pdfDateiName + ".pdf");
    },

    // Grundwaffe aus der Gesamtliste, auch wenn sie selbst nicht exportiert wird
    artLabel(element, source) {
      if (!isSystem(element)) return "Grundwaffe";
      const parent = element.parent_weapon_id
        ? source.find(w => Number(w.id) === Number(element.parent_weapon_id))
        : null;
      if (!parent) return "Wechselsystem (ohne Grundwaffe)";
      return `Wechselsystem zu ${parent.KurzT} (Nr. ${parent.Nummer})`;
    }
  }
};
</script>

<style scoped>
.scrollable-content {
  max-height: 800px;
  overflow-y: auto;
}
</style>